import React, { useEffect,useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import * as actions from '../actions/communicationmoduleactions';
// import GetQuoteOnlineDocumentsUpload from '../components/GetQuoteOnlineDocumentsUpload';
import ReCAPTCHA from "react-google-recaptcha";
import * as appConstants from '../../../overrides/appconstants.js'


export default function GetQuoteOnlineDetails() {

    const state = useSelector(state => state.communicationModuleReducer)
    let getQuoteOnlineDetails = state.getQuoteOnlineDetails;
    let masters = state.masters;
    const dispatch = useDispatch();
    const location = useLocation();
      const [captchaCompleted, setCaptchaCompleted] = useState(false);
    const [captchaError, setCaptchaError] = useState(false);
    const { register: registerGetQuoteOnlineDetails,
        handleSubmit: submitGetQuoteOnlineDetails, setValue: setGetQuoteOnlineDetailsValue, formState: { errors: errorGetQuoteOnlineDetails } } = useForm();

    useEffect(() => {
        try {
            dispatch(actions.getCommunicationModuleMastersForUserEntry());
        } catch (error) {
            console.error('Error in useEffect:', error);
        }
    }, [dispatch]);

    useEffect(() => {
            const urlParams = new URLSearchParams(location.search);
            const utmSourceVal = urlParams.get("utm_source"); // change key name
    
            if (utmSourceVal && utmSourceVal.trim() !== "") {
                let name = "utmSourceName";
                let value = utmSourceVal;
                dispatch(actions.onChangeGetQuoteOnlineDetailsParams({ name, value }));
            }
        }, [location.search]);

    useEffect(() => {
        let valuesToMap = [
            { "userMobileNo": getQuoteOnlineDetails.userMobileNo },
            { "userName": getQuoteOnlineDetails.userName },
            { "userEmail": getQuoteOnlineDetails.userEmail },
            { "preferredLanguage": getQuoteOnlineDetails.preferredLanguage },
            { "userProductTypeId": getQuoteOnlineDetails.userProductTypeId },
            { "userServiceTypeId": getQuoteOnlineDetails.userServiceTypeId },
            { "userRemarks": getQuoteOnlineDetails.userRemarks },
            { "termsCheckbox": getQuoteOnlineDetails.termsCheckbox },
            { "utmSourceName": getQuoteOnlineDetails.utmSourceName },
           /* { "vehCategory": getQuoteOnlineDetails.vehCategory },
            { "vehType": getQuoteOnlineDetails.vehType },
            { "isVehicleFinanced": getQuoteOnlineDetails.isVehicleFinanced }*/,
        ];
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setGetQuoteOnlineDetailsValue(key, i[key])));
    }, [getQuoteOnlineDetails]);

    const onGetQuoteOnlineDetailsSubmit = async (data, e) => {


        if (getQuoteOnlineDetails.termsCheckbox != "Y") {
            alert("Accept terms and Conditions.");
            return;
        }
   if (!captchaCompleted) {
            setCaptchaError(true);
            {
                let dialogeData = {
                       message: `Please complete the CAPTCHA.`,
                       showConfirmPopup: true,
                       isConfirm: false,
                       isInfo: true,
                     }
               
                     await dispatch(actions.toggleConfirmPopup(dialogeData));
                     return true;
             }
           
        }

     var res=   dispatch(actions.saveGetQuoteOnlineMaster());
     if(res===true)
     {
          let dialogeData = {
                       message: `Sucessfully Saved Information.`,
                       showConfirmPopup: true,
                       isConfirm: false,
                       isInfo: true,
                     }
               
                     await dispatch(actions.toggleConfirmPopup(dialogeData));
                     return true;
     }
    }

    const onErrorGetQuoteOnlineDetails = (errorGetQuoteOnlineDetails, e) => console.log(errorGetQuoteOnlineDetails, e);

    const onChangeGetQuoteOnlineDetailsParams = async (e) =>{

  
        let { name, value, checked } = e.target;

        if (name === "userProductTypeId" && value === "983") {
        window.location.href = "https://micustomer.alsagrins.ae/quote?utm_source=website";
        return;
        }
        
        if (name == "termsCheckbox") {
            let value = checked == true ? "Y" : "N";
            await dispatch(actions.onChangeGetQuoteOnlineDetailsParams({ name, value }));
        } else {
            await dispatch(actions.onChangeGetQuoteOnlineDetailsParams({ name, value }));
        }
        if (name == "vehCategory" || name == "isVehicleFinanced" || name == "vehType") {
            await dispatch(actions.onUpdateGetQuoteOnlineDocumentsListFront());
        }
    }

  const handleCaptchaChange = (value) => {
        if (value) {
            setCaptchaCompleted(true);
            setCaptchaError(false);
        } else {
            setCaptchaCompleted(false);
            setCaptchaError(true);
            {
                let dialogeData = {
                       message: `Please complete the CAPTCHA.`,
                       showConfirmPopup: true,
                       isConfirm: false,
                       isInfo: true,
                     }
               
                      dispatch(actions.toggleConfirmPopup(dialogeData));
                     return true;
             }
        }
    };


    let UserMobileNo = <input className={errorGetQuoteOnlineDetails.userMobileNo ? 'form-control  is-invalid' : 'form-control'}
        name="userMobileNo"
        id="userMobileNo"
        disabled={false}
        type="text"
        placeholder="User Mobile No"
        {...registerGetQuoteOnlineDetails("userMobileNo", { required: true,
            pattern: { value: /(^[0][5][0,5,2,6,4,8]{1}[0-9]{7}$)/, message: "Format: 5XXXXXXXX" },
             onChange: (e) => onChangeGetQuoteOnlineDetailsParams(e) })}
    />
    let UserName = <input className={errorGetQuoteOnlineDetails.userName ? 'form-control  is-invalid' : 'form-control'}
        name="userName"
        id="userName"
        disabled={false}
        type="text"
        placeholder="User Name"
        {...registerGetQuoteOnlineDetails("userName", { required: true, 
            
            
            onChange: (e) => onChangeGetQuoteOnlineDetailsParams(e) })}
    />
    let UserEmail = <input className={errorGetQuoteOnlineDetails.userEmail ? 'form-control  is-invalid' : 'form-control'}
        name="userEmail"
        id="userEmail"
        disabled={false}
        type="text"
        placeholder="User Email"
        {...registerGetQuoteOnlineDetails("userEmail", {
            required: "Email is required",
            pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Enter a valid email address"
            },
            onChange: (e) => onChangeGetQuoteOnlineDetailsParams(e)
        })}
    />
    let UserProductTypeId = <select className={errorGetQuoteOnlineDetails.userProductTypeId ? 'form-select  is-invalid' : 'form-select'}
        name="userProductTypeId"
        data-toggle="select2"
        id="userProductTypeId"
        disabled={false}
        {...registerGetQuoteOnlineDetails("userProductTypeId", { required: true, onChange: (e) => onChangeGetQuoteOnlineDetailsParams(e) })}
    >
        <option value=''>---- Select ---- -</option>
        {masters.productsList && masters.productsList.map((applyType) => (
            <option value={applyType.domainValue} key={applyType.domainValue}>
                {applyType.domainValueName}
            </option>))}
    </select>
    let UserServiceTypeId = <select className={errorGetQuoteOnlineDetails.userServiceTypeId ? 'form-select  is-invalid' : 'form-select'}
        name="userServiceTypeId"
        data-toggle="select2"
        id="userServiceTypeId"
        disabled={false}
        {...registerGetQuoteOnlineDetails("userServiceTypeId", { required: true, onChange: (e) => onChangeGetQuoteOnlineDetailsParams(e) })}
    >
        <option value=''>---- Select ---- -</option>
        {masters.productServiceLink && masters.productServiceLink.filter(p => p.productTypeId == getQuoteOnlineDetails.userProductTypeId && p.serviceTypeId != 1 ).map((applyType) => (
            <option value={applyType.serviceTypeId} key={applyType.serviceTypeId} >
                {applyType.serviceTypeName}
            </option>))}
    </select>
    let UserRemarks = <textarea className={errorGetQuoteOnlineDetails.userRemarks ? 'form-control  is-invalid' : 'form-control'}
        name="userRemarks"
        id="userRemarks"
        disabled={false}
        type="text"
        placeholder="User Remarks"
        {...registerGetQuoteOnlineDetails("userRemarks", { required: true, onChange: (e) => onChangeGetQuoteOnlineDetailsParams(e) })}
    />
    let TermsandConditions =
        <input
            type="checkbox"
            id="termsCheckbox"
            className={`form-check-input ${errorGetQuoteOnlineDetails.termsCheckbox ? 'is-invalid' : 'form-check-input'}`}
            name="checkbox"
            style={{ width: "15px", height: "15px" }}
            checked={getQuoteOnlineDetails.termsCheckbox == "Y"}
            value={getQuoteOnlineDetails.termsCheckbox}
            {...registerGetQuoteOnlineDetails("termsCheckbox", {
                required: false,
                onChange: (e) => onChangeGetQuoteOnlineDetailsParams(e)
            })}
        />
    /*let UserVehType = <select className={errorGetQuoteOnlineDetails.vehType ? 'form-select  is-invalid' : 'form-select'}
        name="vehType"
        data-toggle="select2"
        id="vehType"
        {...registerGetQuoteOnlineDetails("vehType", { required: (getQuoteOnlineDetails.userProductTypeId == 982 && getQuoteOnlineDetails.userServiceTypeId == 2), onChange: (e) => onChangeGetQuoteOnlineDetailsParams(e) })}
    >
        <option value=''>----Select-----</option>
        <option value='N'>New Vehicle / مركبة جديدة</option>
        <option value='U'>Used Vehicle / مركبة مستعملة</option>
    </select>
    let VehicleFinanced = <select className={errorGetQuoteOnlineDetails.isVehicleFinanced ? 'form-select  is-invalid' : 'form-select'}
        name="isVehicleFinanced"
        data-toggle="select2"
        id="isVehicleFinanced"
        {...registerGetQuoteOnlineDetails("isVehicleFinanced", { required: (getQuoteOnlineDetails.userProductTypeId == 982 && getQuoteOnlineDetails.userServiceTypeId == 2), onChange: (e) => onChangeGetQuoteOnlineDetailsParams(e) })}
    >
        <option value=''>----Select-----</option>
        <option value='Y'>Yes / نعم</option>
        <option value='N'>No / لا</option>
    </select>
    let VehCategory = <select className={errorGetQuoteOnlineDetails.vehCategory ? 'form-select  is-invalid' : 'form-select'}
        name="vehCategory"
        data-toggle="select2"
        id="vehCategory"
        {...registerGetQuoteOnlineDetails("vehCategory", { required: (getQuoteOnlineDetails.userProductTypeId == 982 && getQuoteOnlineDetails.userServiceTypeId == 3) || (getQuoteOnlineDetails.userProductTypeId == 982 && getQuoteOnlineDetails.userServiceTypeId == 2), onChange: (e) => onChangeGetQuoteOnlineDetailsParams(e) })}
    >
        <option value=''>----Select Vehicale Category-----</option>
        <option value='P'>Personal Vehicle / مركبة خاصة</option>
        <option value='C'>Company Vehicle / مركبة شركة</option>
    </select>*/
    let PreferredLanguage =
        <select
            className={`form-select fw-bold ${errorGetQuoteOnlineDetails.preferredLanguage ? 'is-invalid' : ''}`}
            data-toggle="select2"
            id="preferredLanguage"
            name="preferredLanguage"
            {...registerGetQuoteOnlineDetails("preferredLanguage", { required: true, onChange: (e) => onChangeGetQuoteOnlineDetailsParams(e) })}
        >
     
            <option value='ENG'>ENG</option>
            <option value='AR'>AR</option>
        </select>
                         let Captcha = <ReCAPTCHA
            sitekey={appConstants.CAPTCHA_SITE_KEY}
            // sitekey="6Lflq9QqAAAAACQYldy2S3ece4KtQCKS37F1dfEy"
            onChange={handleCaptchaChange}
        />

    return (
        <>
            <div><ul className="nav nav-tabs nav-bordered mb-3">
            </ul>
                <body>
                    <div class="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-xxl-6 col-lg-5">
                                    <div class="card">
                                        <div class="card-body p-4">
                                            <span class="logo-lg d-block mb-3">
                                                <div class="text-center w-75 m-auto">
                                                    <h4 class="text-black text-center mt-0 mb-3 fw-bold"> REQUEST A QUOTE / اطلب عرض سعر </h4>
                                                </div>
                                            </span>
                                            <ul className="nav nav-tabs nav-bordered my-3">
                                            </ul>
                                            <form className="form-group needs-validation"
                                                onSubmit={submitGetQuoteOnlineDetails(onGetQuoteOnlineDetailsSubmit, onErrorGetQuoteOnlineDetails)} noValidate="noValidate">
                                                <div className="mb-3 ">
                                                    <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span>Mobile No / رقم الهاتف</label>
                                                    {UserMobileNo}
                                                    {(errorGetQuoteOnlineDetails.userMobileNo  ) && (
                                                        <div className='text-danger'>
                                                            {errorGetQuoteOnlineDetails.userMobileNo ?.message }
                                                        </div>
                                                    )}
                                                </div>
                                                
                                                <div className="mb-3 ">
                                                    <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span> Name / الأسم</label>
                                                    {UserName}
                                                </div>
                                                <div className="mb-3 ">
                                                    <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span> Email / البريد الإلكتروني</label>
                                                    {UserEmail}
                                                    {errorGetQuoteOnlineDetails.userEmail?.message && <div className='text-danger'> <span>{errorGetQuoteOnlineDetails.userEmail?.message}</span></div>}
                                                </div>
                                                <div className="mb-3 ">
                                                    <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span> Preferred Language / اللغة المفضلة</label> 
                                                    {PreferredLanguage}
                                                </div>
                                                <div className="mb-3 ">
                                                    <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span> Product Type / نوع المنتج</label>
                                                    {UserProductTypeId}
                                                </div>
                                                <div className="mb-3 ">
                                                    <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span> Service Type / نوع الخدمة المطلوبة</label>
                                                    {UserServiceTypeId}
                                                </div>
                                                {/* {(getQuoteOnlineDetails.userProductTypeId == 982 && getQuoteOnlineDetails.userServiceTypeId == 2) && <div><div className="mb-3 ">
                                                    <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span>Vehicle Type / نوع المركبة</label>
                                                    {UserVehType}
                                                </div>
                                                    <div className="mb-3 ">
                                                        <label htmlFor="inputPassword4" className="ltr-label"><span className='redstar'>*</span>Is the vehicle under bank finance / mortgage?  / هل المركبة مرهونة لدى البنك أو ممولة؟</label>
                                                        {VehicleFinanced}
                                                    </div>
                                                    <div className="mb-3 ">
                                                        <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span>Vehicle Category / فئة المركبة</label>
                                                        {VehCategory}
                                                    </div></div>}
                                                {(getQuoteOnlineDetails.userProductTypeId == 982 && getQuoteOnlineDetails.userServiceTypeId == 3) &&
                                                    <div className="mb-3 ">
                                                        <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span>Vehicle Category / فئة المركبة</label>
                                                        {VehCategory}
                                                    </div>} */}
                                                <div className="mb-3 ">
                                                    <label htmlFor="inputPassword4" className="form-label"><span className='redstar'>*</span> Remarks / ملاحظات</label>
                                                    {UserRemarks}
                                                </div>
                                                {getQuoteOnlineDetails.statusTypeId == 988 && <div className="mb-3 ">
                                                    <h3><span className='redstar'>Additional Information Remarks:- </span></h3>
                                                    <label htmlFor="inputPassword4" className="form-label"><span className='redstar'></span>{getQuoteOnlineDetails.coreSystemRemarks}</label>
                                                </div>}
                                                {/* <GetQuoteOnlineDocumentsUpload /> */}
                                                {getQuoteOnlineDetails.agreeTerms != "Y" && <div class="mb-3">
                                                    <div class="form-check">
                                                        {TermsandConditions}
                                                        {(getQuoteOnlineDetails.preferredLanguage || "ENG") === "ENG" ? (
                                                            <label htmlFor="termsCheckbox" className="form-check text-justify fs-6">
                                                                By consenting to this privacy notice, you are giving us permission to process your personal data specifically for the purposes identified. Consent is required for ASNIC to process all types of personal data, and it must be explicitly given. Where we request sensitive personal data, we are always obligated to inform you why the information is being collected and how it will be used.
                                                                By submitting the documents, you confirm that all documents and information provided by you are valid, accurate, and authentic.
                                                                You may withdraw your consent at any time by submitting a “Data Subject Consent Withdrawal Request” by writing to <a href="mailto:privacy@alsagrins.ae">privacy@alsagrins.ae</a>. Please note that it may take up to 30 days for us to process your request and provide confirmation.
                                                            </label>
                                                        ) : (
                                                            <label htmlFor="termsCheckbox" className="form-check-label text-justify-custom fs-6"
                                                                style={{ textAlign: "-webkit-right" }}>
                                                                <span dir="rtl">
                                                                    بموافقتك على إشعار الخصوصية هذا، فإنك تمنحنا الإذن لمعالجة بياناتك الشخصية للأغراض المحددة فقط. تُعد الموافقة مطلوبة لشركة الصقر الوطنية للتأمين لمعالجة جميع أنواع البيانات      الشخصية، ويجب أن يتم تقديمها بشكل صريح وواضح. وفي حال طلب بيانات شخصية حساسة، فإننا     ملتزمون دائمًا بإبلاغك بسبب جمع هذه المعلومات وكيفية استخدامها. ومن خلال تقديمك       للمستندات فإنك تؤكد أن جميع المستندات والمعلومات المقدمة من قبلك صحيحة وسارية وموثوقة.    يمكنك سحب موافقتك في أي وقت من خلال تقديم "طلب سحب موافقة صاحب البيانات" عبر مراسلتنا        على
                                                                </span>
                                                                <br />
                                                                <a style={{ float: "inline-end" }} href="mailto:privacy@alsagrins.ae">privacy@alsagrins.ae</a>
                                                                <br />
                                                                <span dir="rtl">
                                                                    يرجى العلم بأن معالجة الطلب وتزويدك بالتأكيد قد تستغرق مدة تصل إلى 30 يومًا.
                                                                </span>
                                                                <br />
                                                            </label>
                                                        )}
                                                    </div>
                                                </div>}
                                                {/* {<div class="mb-3">
                                                    <div class="">
                                                        {termsLanguage === 'ENG' ? <label htmlFor="termsCheckbox" className="form-check text-justify fs-6"
                                                            style={{ color: "crimson" }}>

                                                            Kindly ensure to click '<strong>Submit</strong>' after saving the details.
                                                        </label>
                                                            :
                                                            <label htmlFor="termsCheckbox" dir="rtl" className="form-check text-justify fs-6"
                                                                style={{ textAlign: "right", direction: "rtl", unicodeBidi: "plaintext", color: "crimson" }}>
                                                                <span dir="rtl">
                                                                    يرجى التأكد من الضغط على "<bdi dir="ltr"><strong>Submit</strong></bdi>" بعد حفظ البيانات
                                                                </span>
                                                            </label>
                                                        }
                                                    </div>
                                                </div>} */}
                        

        <div className="mb-3">
                                                    {Captcha}
                                                   {/* {captchaError && (<div className="invalid-feedback d-block">Please complete the CAPTCHA.</div>)} */}
                                                </div>
                                                <div id="tooltip-container2">
                                                    <button type="submit" className="btn btn-success float-end"
                                                        data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="Save" ><i className="dripicons-save"></i> Submit</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </body></div>
        </>
    )
}